<div class="header">
  <div>
    <div class="al-page-title">
      <a
        class="al-page-back al-relief-icon al-relief-icon--large al-icon--chevron-left"
        routerLink="/academy"
        [attr.aria-label]="'academy.backToAcademy' | translate"
        [nbTooltip]="'academy.backToAcademy' | translate"
        nbTooltipPlacement="right"
      ><span class="al-relief-glyph" aria-hidden="true"></span></a>
      <h2>{{ title }}</h2>
    </div>
    <p class="subtitle" *ngIf="description">{{ description }}</p>
  </div>
</div>

<app-page-loader *ngIf="!ready"></app-page-loader>

<div class="cert-layout" *ngIf="ready && state">
  <!-- Abschlusstest -->
  <nb-card class="cert-exam" alAnchor="academy.exam">
    <nb-card-header>
      <h6>{{ 'academy.cert.exam' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <!-- Ergebnis eines gerade abgelegten Tests -->
      <div class="cert-result" *ngIf="result" role="status">
        <div class="cert-result__orbi" *ngIf="result.passed" aria-hidden="true">
          <app-orbi-lab type="tutor" [size]="96" [script]="celebrateScript"></app-orbi-lab>
        </div>
        <h3 class="cert-result__title" [class.is-passed]="result.passed" [class.is-failed]="!result.passed">
          {{ (result.passed ? 'academy.cert.passedTitle' : 'academy.cert.failedTitle') | translate: { name: title } }}
        </h3>
        <p class="cert-result__text">
          {{
            (result.passed ? 'academy.cert.passedText' : 'academy.cert.failedText')
              | translate: { correct: result.correct, total: result.total, score: result.percent, pass: state.cert.passPercent }
          }}
        </p>
      </div>

      <!-- Test läuft -->
      <app-academy-quiz
        *ngIf="exam"
        [questions]="exam"
        mode="exam"
        (completed)="onExamCompleted($event)"
      ></app-academy-quiz>

      <!-- Bereit / bestanden / gesperrt -->
      <div class="cert-intro" *ngIf="!exam">
        <ng-container *ngIf="state.earned; else notEarned">
          <div class="cert-earned">
            <span class="cert-earned__badge" aria-hidden="true"><nb-icon icon="award"></nb-icon></span>
            <div>
              <h3 class="cert-earned__title">{{ 'academy.cert.earnedTitle' | translate: { name: title } }}</h3>
              <p class="cert-earned__text">{{ 'academy.cert.earnedScore' | translate: { score: state.bestScore } }}</p>
            </div>
          </div>
        </ng-container>
        <ng-template #notEarned>
          <p class="cert-intro__text" *ngIf="state.examUnlocked">
            {{ 'academy.cert.examIntro' | translate: { n: state.cert.examSize, pass: state.cert.passPercent } }}
          </p>
          <p class="cert-intro__text" *ngIf="!state.examUnlocked">
            {{ 'academy.cert.examLocked' | translate }}
          </p>
        </ng-template>
      </div>
    </nb-card-body>
    <nb-card-footer class="cert-actions" *ngIf="!exam || result">
      <span class="cert-actions__spacer"></span>
      <button
        *ngIf="state.examUnlocked && !state.earned"
        nbButton
        status="primary"
        type="button"
        (click)="startExam()"
      >
        {{ (result ? 'academy.cert.retry' : 'academy.cert.start') | translate }}
      </button>
      <a *ngIf="state.earned" nbButton status="primary" routerLink="/academy">
        {{ 'academy.lesson.backToAcademy' | translate }}
      </a>
    </nb-card-footer>
  </nb-card>

  <!-- Voraussetzungen -->
  <nb-card class="cert-requirements">
    <nb-card-header>
      <h6>{{ 'academy.cert.requirements' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <div class="req" *ngIf="state.cert.requires">
        <nb-icon
          [icon]="state.missingPrerequisite ? 'radio-button-off-outline' : 'checkmark-circle-2-outline'"
          [class.is-done]="!state.missingPrerequisite"
        ></nb-icon>
        <a [routerLink]="['/academy/certificates', state.cert.requires]">
          {{ 'academy.cert.requiresCert' | translate: { name: prerequisiteTitle } }}
        </a>
      </div>
      <div class="req">
        <nb-icon
          [icon]="missing.length ? 'radio-button-off-outline' : 'checkmark-circle-2-outline'"
          [class.is-done]="!missing.length"
        ></nb-icon>
        <span>{{ 'academy.cert.requiresLessons' | translate: { n: state.lessons.length } }}</span>
      </div>
      <app-academy-progress class="req-progress" [done]="state.completed" [total]="state.lessons.length"></app-academy-progress>

      <ng-container *ngIf="missing.length">
        <h5 class="req-missing-title">{{ 'academy.cert.missing' | translate }}</h5>
        <nb-list>
          <nb-list-item *ngFor="let r of missing; trackBy: trackMissing">
            <app-academy-lesson-item
              [lesson]="r.lesson"
              [title]="r.title"
              [subtitle]="r.subtitle"
              [status]="r.status"
            ></app-academy-lesson-item>
          </nb-list-item>
        </nb-list>
      </ng-container>
    </nb-card-body>
  </nb-card>
</div>
